// extracted by mini-css-extract-plugin
export default {"wrapper":"MadeIactivePro_wrapper__EBtP0"};